module.exports = __webpack_public_path__ + "img/icon-tele.375ea7a3.png";